import * as React from "react";
import styled, { css } from "../../../styled/index";
import { FaCheck } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";
const CheckboxWrapperInlineCSS = css `
  display: inline-block;
  &:not(:first-child) {
    margin-left: 10px;
  }
  label {
    display: inline-block;
    margin-left: 6px;
    margin-bottom: 0;
  }
`;
const CheckboxWrapper = styled("div") `
  position: relative;
  ${(props) => props.inline ? CheckboxWrapperInlineCSS : ""};
  label {
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
  }

  &.centered-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;

    & div[class^="checkbox__CheckboxIcon"] {
          transform: translate(-50%, -50%);
    left: 50%;
    }
  }
`;
const CheckboxInput = styled("input") `
  visibility: visible;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin: 0;
`;
const cssChecked = css `
  background: ${({ theme }) => theme.colors.primary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  padding-top: -5px;
  line-height: 18px;
`;
const cssCheckedPartial = css `
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding-top: -5px;
  line-height: 18px;
`;
const CheckboxLabel = styled("label") `
  :before {
    text-align: center;
    height: 18px;
    width: 18px;
    margin-bottom: 0;
    content: " ";
    display: inline-block;
    vertical-align: text-bottom;
    border-radius: 3px;
    cursor: pointer;
    transition: 0.15s all;
    background: transparent;
    color: white;
    ${(props) => props.version === 'v2' ? css `
      border: 2px solid #4B4F5E;
    ` : `border: 1px solid #949494;`};
    ${(props) => props.checkedPartial ? cssCheckedPartial : (props.checked ? cssChecked : "")}
  }
`;
const CheckboxIcon = styled("div") `
    position: absolute;
    top: 50%;
    transform: translateY(-40%);
    left: 3px;
    font-size: 12px;
    pointer-events: none;
    opacity: 0;
    ${(props) => props.checkedPartial ? css `
      opacity: 1;
      color: ${lighten(0.2, props.theme.colors.primary)};
    ` : (props.checked ? css `
      opacity: 1;
      color: ${props.theme.colors.primary_text};
    ` : "")}
`;
export const Checkbox = (props) => (React.createElement(CheckboxWrapper, { inline: props.inline, className: props.className },
    React.createElement(CheckboxInput, { id: props.id, type: "checkbox", name: props.name, onClick: props.onClick, onChange: props.onChange, required: props.required, checked: props.checked }),
    React.createElement(CheckboxLabel, { htmlFor: props.id, checked: props.checked, checkedPartial: props.checkedPartial, version: props.version ? props.version : 'v1', style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '620px' } }, props.label && React.createElement("span", { className: "m-l-2" }, props.label)),
    React.createElement(CheckboxIcon, { checkedPartial: props.checkedPartial || false, checked: props.checked },
        React.createElement(FaCheck, null))));
//# sourceMappingURL=index.js.map